import type { IErrorResponse, PasswordRequest } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const useSetPassword = (): UseMutationResult<
  [],
  IErrorResponse,
  PasswordRequest
> => {
  const { t } = useTranslation('messages');
  return useMutation({
    mutationFn: (data) => api.post(urls.setPassword, data),
    onSuccess() {
      standaloneToast({
        status: 'success',
        title: t('yourPasswordChangeSuccessfully'),
      });
    },
  });
};

export default useSetPassword;
